<!-- 批量删除文件 -->
<template>
  <div class="BatchDeleteFile">
    <el-dialog
      class="AbnormallyWraning"
      v-if="HintMessageList.switch"
      :visible.sync="HintMessageList.switch"
      width="600px"
      center
      >
      <div class="AbnormallyContent">
        <div class="Hint">{{$t('lang.BatchFileUse')}}</div>
        <div class="MessageList" v-for="(item,index) in MessageList" :key="index">
          <div class="MessageListWrap">
              <span class="MessageTitle">
                {{item.title}}
              </span>
              <span class="MessageTime">
                  {{TimeListTransition(item.startTime) + ' - ' + TimeListTransition(item.endTime) }}
              </span>
          </div>
        </div>
        <div class="Hint">{{$t('lang.DeleteEventFile')}}</div>
      </div>
      <div slot="footer" class="AbnormallyFooter">
        <el-button class="cancel" @click="cancel">{{$t('lang.cancel')}}</el-button>
        <el-button type="primary" @click="Confirm" :loading="HintMessageList.loading">{{$t('lang.Confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    HintMessageList: {
      type: Object,
      default: () => ({
        switch: false,
        isBatch: false,
        list: [],
        loading: false
      })
    }
  },
  data () {
    return {
      // 列表
      MessageList: []
    }
  },
  created () {
    this.DisposeList()
  },
  mounted () {

  },
  methods: {
    // 处理列表
    DisposeList () {
      this.MessageList = []
      const list = this.HintMessageList.list
      this.MessageList = list
    },
    // 转换显示时间
    TimeListTransition (time) {
      if (typeof time != 'number') {
        return ''
      }
      return Outil.TransitionCurrentTime(new Date(time))
    },
    // 确认删除
    Confirm () {
      this.$emit('ConfirmBatchDelete', this.HintMessageList.isBatch)
    },
    // 取消
    cancel () {
      this.$emit('CancelBatchDelete')
    }
  }
}
</script>

<style scoped lang="less">
.BatchDeleteFile {
  ::v-deep .AbnormallyWraning{
    text-align: left;
    .el-dialog__header{
      height: 56px;
      line-height: 56px;
      border-bottom: none;
      padding-left: 0px;
    }
    .el-dialog__body{
      padding-top: 0px;
      padding-left: 30px;
      padding-right: 20px;
    }
    .el-dialog__footer{
      padding: 0px 0 25px;
    }
    .AbnormallyContent{
      max-height: 205px;
      padding-right: 10px;
      overflow-y: auto;
      font-size: 14px;
      color: #DBDBDB;
      .Hint {
        line-height: 16px;
        margin: 10px 0;
      }
      .MessageListWrap{
        font-size: 14px;
        margin: 10px 0;
        .MessageTitle{
          color: #E56464;
        }
        .MessageTime {
          color: #666666;
        }
      }
    }
    .AbnormallyFooter{
      padding-right: 10px;
      text-align: right;
      .el-button {
        width: 80px;
        padding: 8px 12px;
        color: #FFFFFF;
      }
      .el-button--default {
        background: #666666;
      }
      .el-icon-loading {
        position: absolute;
        left: 3px;
      }
    }
  }
}

</style>
